import React from 'react';
import { Link } from 'react-router-dom';

const RecommendationAlert = ({ recommendations }) => {
  const displayCount = recommendations.length > 9 ? '9+' : recommendations.length;

  return (
    <div className="recommendation-alert-card">
      <div className="recommendation-left">
        <h2>✨ New Recommendations!</h2>
        <p>You have {displayCount} new recommendations waiting for review.</p>
        <Link to="/recommendations" className="review-link">View Recommendations &gt;</Link>
      </div>
      <div className="recommendation-right">
        {recommendations.slice(0, 3).map((rec, index) => (
          <img
            key={index}
            src={rec.image || '/static/placeholder.jpg'}
            className="rec-thumb"
            alt={rec.title}
          />
        ))}
      </div>
    </div>
  );
};

export default RecommendationAlert;